import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class CoverageEligibilityResponseInsuranceBenefitPeriod extends BackboneElement {
    static __className = 'CoverageEligibilityResponseInsuranceBenefitPeriod';

    __objectStructure = {
        dateQualifier: String,
        dateOfServiceEnd: String,
        dateOfServiceStart: String,
    };

    constructor(constructJson, className = 'CoverageEligibilityResponseInsuranceBenefitPeriod') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
